import Vue from 'vue';
import Vuex from 'vuex';
import UserStore from './modules/User.store'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    UserStore
  },
})


// WEBPACK FOOTER //
// ./src/store/index.js